import React from 'react';
import type ProjectSettingsServiceDeskWidgetSettingsType from '@atlassian/jira-spa-apps-project-settings-service-desk-widget-settings/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskWidgetSettings = lazyForPaint<
	typeof ProjectSettingsServiceDeskWidgetSettingsType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-widget-settings", jiraSpaEntry: "async-project-settings-service-desk-widget-settings" */ '@atlassian/jira-spa-apps-project-settings-service-desk-widget-settings'
		),
);

const AsyncProjectSettingsServiceDeskWidgetSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskWidgetSettings}
		pageId="project-settings-widget-settings"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskWidgetSettings;
